import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Layout } from '../shared/layout';
import AppRoutes from './app-routes';
import Logout from '../authentication/Logout';
import { ProtectedRoute } from '../authentication/ProtectedRoute';

export default function AppIndex() {
    return (
        <Routes>
            <Route
                path="/*"
                element={
                    <ProtectedRoute>
                        <Layout>
                            <AppRoutes />
                        </Layout>
                    </ProtectedRoute>
                }
            />
            <Route path="/logout" element={<Logout />} />
        </Routes>
    );
}
